import {
    GET_ROLE, SET_ROLE,
    GET_DETAILS, SET_DETAILS,
    GET_DIVISION, SET_DIVISION,
    GET_DISTRICT, SET_DISTRICT,
    GET_STORE, SET_STORE,
    GET_LOCATION, SET_LOCATION,
    SET_SEARCHRESULT, SET_EXPORTTOEXCEL,
    SET_CUSTOMER_COMMENTS, GET_CUSTOMER_COMMENTS,
    GET_STORE_DISTRICT, SET_STORE_DISTRICT, SET_APIMKEY, GET_APIMKEY,
    GET_USERSFKEYMAP, SET_USERSFKEYMAP,
    GET_ISSUES, SET_ISSUES, GET_SOURCE, SET_SOURCE,
    GET_CATEGORY, SET_CATEGORY,
    GET_COMMENTTYPE, SET_COMMENTTYPE, GET_STATUS, SET_STATUS
} from './customerCommentsAction';
const initialState = {
    role: '',
    details: {
        districtId: "",
        districtName: "",
        divisionId: "",
        divisionName: "",
        roleDesc: "",
        storeId: "",
        storeName: "",
        userId: ""
    },
    division: [],
    district: [],
    issues: [],
    source: [],
    category: [],
    status: [],
    commenttype: [],
    store: [],
    location: [],
    customerCommentsData: {
        divisionId: '',
        districtId: '',
        storeId: '',
        location: '',
        openFrom: '',
        openTo: '',
        caseId: '',
        escalations: '',
        caseType: '',
        caseStatus: '',
        edm: '',
        fromDt: '',
        toDt: '',
        contactId: '',
        followUpStatus: '',
        searchObj: '',
        FieldName: '',
        SortBy: '',
        PageNo: '',
        RowCount: '',
        userRole: ''
    }
};
const customerComments = (state = initialState, action) => {
    switch (action.type) {
        case GET_ROLE:
            return Object.assign({}, state, {
                role: action.value
            })
        case SET_ROLE:
            return Object.assign({}, state, {
                role: action.value
            })
        case GET_APIMKEY:
            return Object.assign({}, state, {
                key: action.value
            })
        case SET_APIMKEY:
            return Object.assign({}, state, {
                key: action.value
            })
        case GET_USERSFKEYMAP:
            return Object.assign({}, state, {
                userSFMap: action.value
            })
        case SET_USERSFKEYMAP:
            return Object.assign({}, state, {
                userSFMap: action.value
            })
        case GET_DETAILS:
            return Object.assign({}, state, {
                details: action.value
            })
        case SET_DETAILS:
            return Object.assign({}, state, {
                details: action.value
            })
        case GET_DIVISION:
            return Object.assign({}, state, {
                division: action.value
            })
        case SET_DIVISION:
            return Object.assign({}, state, {
                division: action.value
            })
        case GET_ISSUES:
            return Object.assign({}, state, {
                issues: action.value
            })
        case SET_ISSUES:
            return Object.assign({}, state, {
                issues: action.value
            })
        case GET_SOURCE:
            return Object.assign({}, state, {
                source: action.value
            })
        case SET_SOURCE:
            return Object.assign({}, state, {
                source: action.value
            })
        case GET_STATUS:
            return Object.assign({}, state, {
                status: action.value
            })
        case SET_STATUS:
            return Object.assign({}, state, {
                status: action.value
            })
        case GET_CATEGORY:
            return Object.assign({}, state, {
                category: action.value
            })
        case SET_CATEGORY:
            return Object.assign({}, state, {
                category: action.value
            })
        case GET_COMMENTTYPE:
            return Object.assign({}, state, {
                commenttype: action.value
            })
        case SET_COMMENTTYPE:
            return Object.assign({}, state, {
                commenttype: action.value
            })
        case GET_DISTRICT:
            return Object.assign({}, state, {
                district: action.value
            })
        case SET_DISTRICT:
            return Object.assign({}, state, {
                district: action.value
            })
        case SET_SEARCHRESULT:
            return Object.assign({}, state, {
                searchResult: action.value
            })
        case SET_EXPORTTOEXCEL:
            return Object.assign({}, state, {
                exportToExcel: action.value
            })
        case GET_STORE:
            return Object.assign({}, state, {
                store: action.value
            })
        case SET_STORE:
            return Object.assign({}, state, {
                store: action.value
            })
        case GET_STORE_DISTRICT:
            return Object.assign({}, state, {
                store: action.value
            })
        case SET_STORE_DISTRICT:
            return Object.assign({}, state, {
                store: action.value
            })
        case GET_LOCATION:
            return Object.assign({}, state, {
                location: action.value
            })
        case SET_LOCATION:
            return Object.assign({}, state, {
                location: action.value
            })
        case SET_CUSTOMER_COMMENTS:
            return Object.assign({}, state, {
                customerCommentsData: action.value
            })
        case GET_CUSTOMER_COMMENTS:
            return Object.assign({}, state, {
                customerCommentsData: action.value
            })
        default:
            return state;
    }
}
export default customerComments;